<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="科室名称">
              <a-input placeholder="请输入科室名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="科室code">
              <a-input placeholder="请输入科室code" v-model="queryParam.code"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="是否启用">
              <a-radio-group v-model="queryParam.enabled" >
                <a-radio-button value="0">
                  否
                </a-radio-button>
                <a-radio-button value="1">
                  是
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <tempConfigDept-modal ref="modalForm" @ok="modalFormOk"></tempConfigDept-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import TempConfigDeptModal from './modules/TempConfigDeptModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "TempConfigDeptList",
    mixins:[JeecgListMixin],
    components: {
      TempConfigDeptModal
    },
    data () {
      return {
        description: '项目配置-知识库-科室管理页面',
        // 表头
        columns: [
		   {
            title: '科室名称',
            align:"center",
            dataIndex: 'name'
           },
		   {
            title: 'CODE',
            align:"center",
            dataIndex: 'code'
           },
		   {
            title: '是否启用',
            align:"center",
            dataIndex: 'enabled_dictText',
           },
		   {
            title: '关键字',
            align:"center",
         ellipsis: true, //表格省略
            dataIndex: 'keyword',
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/tempconfig/tempConfigDept/list",
          delete: "/tempconfig/tempConfigDept/delete",
       },
    }
  },
  computed: {
  },
    methods: {
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>